(() => {
  const initPicker = (picker) => {
    if (picker.dataset.utzDropdownReady === 'true') return;
    picker.dataset.utzDropdownReady = 'true';

    const dropdowns = [...picker.querySelectorAll('[data-product-option-dropdown]')];
    const controls = [...picker.querySelectorAll('[data-product-option-control]')];

    const closeOthers = (active) => {
      dropdowns.forEach((dropdown) => {
        if (dropdown !== active) dropdown.removeAttribute('open');
      });
    };

    const syncControl = (control) => {
      const position = control.dataset.optionPosition;
      const select = picker.querySelector(`[data-product-option-select][data-option-position="${position}"]`);
      if (!select) return;

      const current = control.querySelector('[data-product-option-current]');
      if (current) current.textContent = select.value;

      control.querySelectorAll('[data-product-option-value]').forEach((button) => {
        const option = [...select.options].find((item) => item.value === button.dataset.productOptionValue);
        button.disabled = !option || option.disabled;
        button.setAttribute('aria-selected', String(button.dataset.productOptionValue === select.value));
      });
    };

    const syncAll = () => controls.forEach(syncControl);

    dropdowns.forEach((dropdown) => {
      dropdown.addEventListener('toggle', () => {
        if (dropdown.open) closeOthers(dropdown);
      });
    });

    controls.forEach((control) => {
      const position = control.dataset.optionPosition;
      const select = picker.querySelector(`[data-product-option-select][data-option-position="${position}"]`);
      const dropdown = control.querySelector('[data-product-option-dropdown]');
      if (!select || !dropdown) return;

      control.querySelectorAll('[data-product-option-value]').forEach((button) => {
        button.addEventListener('click', () => {
          if (button.disabled) return;
          select.value = button.dataset.productOptionValue;
          select.dispatchEvent(new Event('change', { bubbles: true }));
          syncAll();
          dropdown.removeAttribute('open');
        });
      });

      select.addEventListener('change', () => window.requestAnimationFrame(syncAll));
    });

    document.addEventListener('click', (event) => {
      if (picker.contains(event.target)) return;
      dropdowns.forEach((dropdown) => dropdown.removeAttribute('open'));
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      dropdowns.forEach((dropdown) => dropdown.removeAttribute('open'));
    });

    syncAll();
  };

  const init = () => document.querySelectorAll('[data-product-option-selectors]').forEach(initPicker);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
